<template>
    <div class="mobile-menu">
        <button @click="toggleMenu" class="hamburger-menu">
            <img class="menu-img" :class="{ active: !menuOpen}" src="../../../images/header/hamburger.png" alt="Menu" />
        </button>

        <Transition name="fade">
            <div v-show="menuOpen" class="menu-container">
                <ul class="menu-list">
                    <li v-for="(menu, key) in menuItems" :key="key" class="menu-item"
                        :class="{ active: activeSubMenu === key }"
                        @click="menu.items ? toggleSubMenu(key) : navigate(menu.value, menu.label, menu.label)">
                        <div class="menu-item-header">
                            <span>{{ menu.label }}</span>
                            <img v-if="menu.items" class="toggle-icon"
                                :style="{ transform: activeSubMenu === key ? 'rotate(180deg)' : 'rotate(0deg)' }"
                                src="../../../images/dashboard/down-blue.png" alt="toggle" />
                        </div>
                        <Transition name="submenu-fade">
                            <ul :class="{ show: activeSubMenu === key }" class="submenu-list">
                                <li v-for="(subItem, index) in menu.items" :key="index"
                                    @click="navigate(subItem.value, subItem.label, menu.label)">
                                    <a> {{ subItem.label }} </a>
                                </li>
                            </ul>
                        </Transition>
                    </li>
                </ul>
            </div>
        </Transition>
    </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
    name: "smallMenu",
    data() {
        return {
            menuOpen: false,
            activeSubMenu: null,
            menuItems: {
                kits: {
                    label: "Test Kits",
                    items: [
                        { label: "Management", value: 0 },
                        { label: "Outliers", value: 4 },
                        // { label: "Import Kits", value: 12 },
                        { label: "Import WS Kits", value: 19 },
                        { label: "WS Kits", value: 20 },
                        { label: "Import Amazon kits", value: 13 },
                        { label: "Inactive Kits", value: 15 },
                        { label: "Problematic Kits", value: 24 }
                    ],
                },
                user: {
                    label: "User",
                    items: [
                        { label: "Admins", value: 1 },
                        { label: "Lab Operators", value: 2 },
                        { label: "MCT Users", value: 22 },
                        { label: "Customers", value: 8 },
                    ],
                },
                inventory: {
                    label: "Inventory",
                    items: [
                        { label: "Kit Generation", value: 14 },
                        { label: "Items", value: 18 },
                        { label: "Amazon", value: 16 },
                    ],
                },
                order: {
                    label: "Reports",
                    items: [
                        { label: "Woo", value: 11 },
                        { label: "Sales", value: 17 },
                    ],
                },
                automation: {
                    label: "Automation",
                    items: [
                        // { label: "Job Logs", value: 10 },
                        { label: "User Logs", value: 21 }
                    ],
                },
                tool: {
                    label: "Tools",
                    items: [
                        { label: "QR Generator", value: 6 },
                        { label: "URL Generator", value: 7 },
                    ],
                },
                others: {
                    label: "Other",
                    items: [
                        { label: "Research", value: 3 },
                        { label: "Research 2 (Map Analysis)", value: 23 },
                        { label: "Federal Holidays", value: 9 },
                    ],
                },
                lab: {
                    label: "Lab Operator",
                    value: 22,
                },

            },
        };
    },
    mounted() {
        document.addEventListener("click", this.handleClickOutside);
    },
    beforeUnmount() {
        document.removeEventListener("click", this.handleClickOutside);
    },
    methods: {
        ...mapActions([
            "setStatusFilter",
            "setOverDueByShipped",
            "getAdminInfoList",
            "setAdminPginationPage",
            "getLabOperatorInfoList",
            "sendSearchReqAnalytics",
            "sendSearchReqAnalyticsAll",
            "setAnalyticsHead",
            "getPendingInfoList",
            "getAverageReportResultList",
            "getContactCustomers",
            "setCustomerCount",
            "getFederalHolidays",
            "getScheduledJoblogs",
            "setLoader",
            "resetState",
            "setViewReport",
            "setInventory",
            "setLocations",
            "setPagination",
            "setFillocation",
            "setFilItem",
            "setItems",
            "setPage",
            "setInvKits",
            "getInactiveList",
            "setAmazonFbaInv",
            "setSalesData",
            "setWooSalesData",
            "setShowinvkit",
            "setCityState",
            "setOverDueByStyle",
            "getMtcLabUserInfoList"
        ]),
        handleClickOutside(event) {
            const menuElement = this.$el;
            if (this.menuOpen && !menuElement.contains(event.target)) {
                this.menuOpen = false;
                this.activeSubMenu = null;
            }
        },
        toggleMenu() {
            if (this.menuOpen) {
                this.menuOpen = false;
                this.activeSubMenu = null;
            } else {
                this.menuOpen = true;
                this.activeSubMenu = null;
            }
        },
        toggleSubMenu(key) {
            if (this.activeSubMenu === key) {
                this.activeSubMenu = null;
            } else {
                this.activeSubMenu = null;
                this.$nextTick(() => {
                    this.activeSubMenu = key;
                });
            }
        },
        navigate(val, label, main_label) {
            for (let key in this.showsubmenu) {
                this.showsubmenu[key] = false;
            }
            this.menuOpen = false;
            this.activeSubMenu = null;
            // Show loader immediately on click, hide when data arrives
            this.setLoader(true);
            if (this.$route.path !== '/dashboard') {
                this.$router.push('/dashboard').then(() => {
                    this.$nextTick(() => {
                        this.navigate(val, label, main_label);
                    });
                });
                return;
            }
            this.resetState();
            let show_state = false;
            if (val == 0 || val == 4) {
                show_state = true;
            }
            this.$eventBus.$emit("breadcrums", {
                path: [{ text: main_label, link: "/dashboard" },
                { text: label }], show: show_state
            })

            // Emit title immediately so the UI switches instantly
            if (val === 18 ) {
                this.$eventBus.$emit("title", { show: false, value: 14, label: label });
            } else {
                this.$eventBus.$emit("title", { show: false, value: val, label: label });
            }

            if (val === 0) {
                this.setStatusFilter([]);
                this.getAdminInfoList("kits");
                this.$eventBus.$emit("showoutlinerfilters", { showfilter: true, value: val });
            } else if (val === 1) {
                this.setAdminPginationPage(null).then(() => {
                    this.getAdminInfoList("admins");
                });
            } else if (val === 2) {
                this.setAdminPginationPage(null).then(() => {
                    this.getLabOperatorInfoList("labOps");
                });
            } else if (val === 22) {
                this.setAdminPginationPage(null).then(() => {
                    this.getMtcLabUserInfoList("mtcLab").then(() => {
                        this.setLoader(false);
                    });
                });
            } else if (val === 3 || val === 23) {
                this.sendSearchReqAnalytics().then(res => {
                    this.setAnalyticsHead({ status: 3, type: null, show: false, item: null, count: null, total: null });
                });
                this.sendSearchReqAnalyticsAll();
                this.setCityState();
            } else if (val === 4) {
                this.setStatusFilter([]);
                this.setOverDueByShipped(null);
                this.setOverDueByStyle(null);
                this.getPendingInfoList("pending");
            } else if (val === 5) {
                this.setAdminPginationPage(null).then(() => {
                    this.getAverageReportResultList("avg");
                });
            } else if (val === 8) {
                this.setAdminPginationPage(null).then(() => {
                    this.setCustomerCount(0).then(() => {
                        this.getContactCustomers(null);
                    });
                });
            } else if (val === 9) {
                this.getFederalHolidays();
            } else if (val === 10) {
                this.getScheduledJoblogs().then(() => {
                    this.setLoader(false);
                });
            } else if (val === 14) {
                this.setLocations();
                this.setItems();
                this.setFillocation('');
                this.setFilItem('');
                this.setInvKits(false);
                this.setPage(1).then(() => {
                    this.setInventory().then(async res => {
                        this.setLoader(false);
                        this.setShowinvkit(true);
                    });
                });
            } else if (val === 15) {
                this.getInactiveList("kits");
            } else if (val === 16) {
                this.setAmazonFbaInv();
            } else if (val === 17) {
                this.setSalesData().then(() => {
                    this.setLoader(false);
                });
                this.setWooSalesData();
            } else if (val === 18) {
                this.setLocations();
                this.setItems();
                this.setFillocation('');
                this.setFilItem('');
                this.setInvKits(false);
                this.setPage(1).then(() => {
                    this.setInventory().then(async res => {
                        this.setLoader(false);
                        this.setShowinvkit(false);
                    });
                });
            }  else if (val === 22) {
              this.$router.push({ path: "/lab/dashboard" });
            } else {
                // For items without API calls (6, 7, 11, 12, 13, 19, 20, 21)
                this.setLoader(false);
            }
        }
    },
};
</script>

<style scoped>
.mobile-menu {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
}

.hamburger-menu {
    background: none;
    border: none;
    cursor: pointer;
}

.menu-img {
    width: 30px;
    height: 30px;
}

.menu-img.active {
    filter: invert(40%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(60%) contrast(100%);
}

.menu-container {
    position: fixed;
    top: 70px;
    left: 0;
    width: 100vw;
    background: #e9e9e9;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1000;
}

.menu-list {
    list-style: none;
    padding: 0;
    margin: 0;
    padding-top: 18px;
    padding-bottom: 100px;
    color: #666;
    background: #ffffff;
    margin-top: 1px;
}

.menu-item {
    padding: 15px 20px;
    cursor: pointer;
    font-weight: 400;
    user-select: none;
    font-size: 17px;
}

.menu-item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}

.menu-item.active {
    color: #005eb8;
    padding-bottom: 0px;
}

.submenu-list {
    list-style: none;
    padding: 0;
    margin-top: 10px;
    padding-left: 20px;
    background-color: white;
    display: none;
}

.show {
    display: block;
}

.submenu-list li {
    padding: 12px 0;
    cursor: pointer;
    color: #666;
    font-weight: 400;
}

.submenu-list li:hover {
    color: #005eb8;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.1s ease;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.toggle-icon {
    width: 17px;
    height: 17px;
    transition: transform 0.1s ease;
}

.submenu-fade-enter-active,
.submenu-fade-leave-active {
    transition: opacity 0.3s ease, transform 0.3s ease;
}

.submenu-fade-enter,
.submenu-fade-leave-to {
    opacity: 0;
    transform: translateY(-5px);
}

.submenu-fade-enter-to {
    opacity: 1;
    transform: translateY(0);
}
</style>